// Shared constants and data for FunAsia Digital website

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const USD_TO_AED = 3.67; // Exchange rate

// Brand assets
export const LOGO_URL = "https://customer-assets.emergentagent.com/job_1b7e3ff3-a6f2-4f8b-ba70-0b0056d06e3d/artifacts/arydq0cs_funasi%20digital.png";
export const CUSTOMER_JOURNEY_URL = "https://customer-assets.emergentagent.com/job_1b7e3ff3-a6f2-4f8b-ba70-0b0056d06e3d/artifacts/23hv1ind_customer-journey%20picture.png";

// Featured packages — prices in USD; converted dynamically by CurrencyContext
export const FEATURED_PACKAGES = [
  {
    id: 1,
    name: "AI SEO for SMB",
    priceUSD: 399,
    priceSuffix: "/mo",
    setupFeeUSD: 399,
    description: "Perfect for Salons, Spas & Wellness. AI Workforce handles inquiries, reviews, and promotions 24/7.",
    features: ["AI Receptionist", "Reputation Management", "Social Media AI", "Listing Management"],
    link: "https://login.funasiadigital.com/public/store/FUNA/default/package/SOL-c8f7263b-f2d7-47b0-804e-4a791fd84577",
    popular: false
  },
  {
    id: 2,
    name: "Starter Package",
    priceUSD: 799,
    priceSuffix: "/mo",
    setupFeeUSD: 799,
    description: "Perfect for general business and startups. Complete AI workforce solution for lead capture and growth.",
    features: ["Conversations AI Premium", "Local SEO & Listings", "Email Marketing", "AI Workflows"],
    link: "https://login.funasiadigital.com/public/store/FUNA/default/package/SOL-575b457a-c112-44c7-b333-643ca4c2291d",
    popular: false
  },
  {
    id: 3,
    name: "Growth Package",
    priceUSD: null,
    priceLabel: "Custom",
    priceSuffix: "",
    setupFeeLabel: "Contact Us",
    description: "Never miss an opportunity. Full AI workforce with reputation management and social marketing.",
    features: ["All Starter Features", "Reputation AI Premium", "Campaigns Pro", "Citation Builder"],
    link: "https://login.funasiadigital.com/public/store/FUNA/default/package/SOL-24faf47a-924e-4666-99e9-4c1c3572f01e",
    popular: true
  },
  {
    id: 4,
    name: "Authority Package",
    priceUSD: null,
    priceLabel: "Custom",
    priceSuffix: "",
    setupFeeLabel: "Contact Us",
    description: "Complete digital authority solution. Enterprise-level AI workforce for maximum growth.",
    features: ["All Growth Features", "Social Marketing Pro", "Advanced Automations", "Priority Support"],
    link: "https://login.funasiadigital.com/public/store/FUNA/default/package/SOL-56e38262-aceb-4769-8528-3a6525f29c4e",
    popular: false
  }
];

// Placeholder testimonials (swap with real client data when ready)
export const TESTIMONIALS = [
  {
    id: 1,
    name: "Priya M.",
    role: "Owner",
    company: "Spice Route Restaurant",
    quote: "After running SmartReach for 90 days, our weekend foot traffic was up significantly. The radio + hyperlocal mobile combo brought in customers we would never have reached on Google alone.",
    metric: "+38% weekend walk-ins",
    avatarColor: "from-orange-primary to-orange-secondary"
  },
  {
    id: 2,
    name: "Rajiv K.",
    role: "Marketing Director",
    company: "Bombay Bazaar (3 locations)",
    quote: "The dual loyalty system is the real game-changer. Customers are coming back twice as often, and we can finally see which campaigns drive actual store visits — not just clicks.",
    metric: "2x repeat visits",
    avatarColor: "from-orange-secondary to-orange-primary"
  },
  {
    id: 3,
    name: "Anita S.",
    role: "Founder",
    company: "Glow Beauty Spa",
    quote: "We tried Facebook and Google for years. FunAsia's hyperlocal targeting + AI receptionist booked our calendar solid in the first month. We finally know what marketing actually works.",
    metric: "Calendar booked solid",
    avatarColor: "from-orange-primary to-orange-secondary"
  }
];

// Placeholder mini case studies (swap with real data)
export const CASE_STUDIES = [
  {
    id: 1,
    industry: "Restaurant",
    location: "Dallas, TX",
    headline: "Local Restaurant Drives 38% More Weekend Walk-Ins",
    summary: "A regional restaurant group used SmartReach radio + hyperlocal mobile within a 5-mile radius for 90 days.",
    stats: [
      { label: "Weekend foot traffic", value: "+38%" },
      { label: "Repeat customer rate", value: "+22%" },
      { label: "Cost per visit", value: "−41%" }
    ]
  },
  {
    id: 2,
    industry: "Retail",
    location: "Multi-city",
    headline: "Specialty Retailer Doubles Repeat Visits With Loyalty",
    summary: "A specialty retailer activated the dual-points loyalty system across radio, app, and in-store touchpoints.",
    stats: [
      { label: "Repeat visit rate", value: "2.0x" },
      { label: "Avg. basket size", value: "+18%" },
      { label: "Active loyalty members", value: "12K+" }
    ]
  }
];
